export default "__VITE_ASSET__0FEIBpHP__"